import script from "./FordBlacklistSyncCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FordBlacklistSyncCard.vue?vue&type=script&setup=true&lang=js"

import "./FordBlacklistSyncCard.vue?vue&type=style&index=0&id=24b7c9bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b7c9bb"]])

export default __exports__